// email validation
export const isValidEmail = (email: string) : boolean => {
  return /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email);
}

// phone validation
export const isValidPhone = (phone: string): boolean => {
  return /^\+?[1-9][0-9]{7,14}$/.test(phone);
}